import React from 'react'
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { Card } from 'antd'

interface OperationsData {
  date: string
  completed: number
  inProgress: number
  pending: number
}

interface OperationsOverTimeChartProps {
  data: OperationsData[]
  height?: number
  title?: string
}

export const OperationsOverTimeChart: React.FC<OperationsOverTimeChartProps> = ({
  data,
  height = 300,
  title = 'Operations Activity Over Time',
}) => {
  return (
    <Card title={title} bordered style={{ marginBottom: '24px' }}>
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis label={{ value: 'Operations', angle: -90, position: 'insideLeft' }} />
          <Tooltip contentStyle={{ backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9' }} />
          <Legend />
          <Area
            type="monotone"
            dataKey="completed"
            stackId="1"
            stroke="#52c41a"
            fill="#52c41a"
            name="Completed"
            fillOpacity={0.6}
          />
          <Area
            type="monotone"
            dataKey="inProgress"
            stackId="1"
            stroke="#1890ff"
            fill="#1890ff"
            name="In Progress"
            fillOpacity={0.6}
          />
          <Area
            type="monotone"
            dataKey="pending"
            stackId="1"
            stroke="#faad14"
            fill="#faad14"
            name="Pending"
            fillOpacity={0.6}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Card>
  )
}
